import { apiClient } from '@/lib/api/client';
import type {
  DeliveryTracking,
  DeliveryCompanyOption,
  UpdateDeliveryTrackingPayload,
  UpdateDeliveryStatusPayload,
} from '../types/delivery-tracking.types';

interface ApiData<T> {
  data: T;
}

export const deliveryTrackingService = {
  async getOrderDeliveryTracking(orderId: string): Promise<DeliveryTracking[]> {
    const response = await apiClient.get<ApiData<DeliveryTracking[]>>(
      `/delivery-tracking/order/${orderId}`
    );
    return response.data?.data ?? [];
  },

  async getActiveDeliveryCompanies(): Promise<DeliveryCompanyOption[]> {
    const response = await apiClient.get<ApiData<DeliveryCompanyOption[]>>(
      '/delivery-companies/active'
    );
    return response.data?.data ?? [];
  },

  // `orderId` is only used by the caller for cache invalidation — the
  // endpoint itself is keyed by the tracking `refId`.
  async updateDeliveryTracking(
    { refId, deliveryCompanyRefId, trackingNumber, status }: UpdateDeliveryTrackingPayload
  ): Promise<DeliveryTracking | null> {
    const response = await apiClient.put<ApiData<DeliveryTracking>>(
      `/delivery-tracking/${refId}`,
      { deliveryCompanyRefId, trackingNumber, status }
    );
    return response.data?.data ?? null;
  },

  // `orderId` is only used by the caller for cache invalidation — the
  // endpoint itself is keyed by the tracking `refId`.
  async updateDeliveryStatus(
    { refId, status, statusDescription, location }: UpdateDeliveryStatusPayload
  ): Promise<DeliveryTracking | null> {
    const response = await apiClient.put<ApiData<DeliveryTracking>>(
      `/delivery-tracking/${refId}/status`,
      { status, statusDescription, location }
    );
    return response.data?.data ?? null;
  },
};
